import { Component, effect, inject, resource, signal } from '@angular/core';
import { TAGImageCategory } from '../../../models/tagimagecategory';
import { TAGImage } from '../../../models/tagimage';
import { ApiService } from '../../api.service';
import { TranslatePipe } from '@ngx-translate/core';
import { SkeletonModule } from 'primeng/skeleton';
import { Masonry } from '../../components/masonry/masonry';
import { DialogService } from 'primeng/dynamicdialog';
import {
  ImageDetailsDialog,
  ImageDetailsDialogData,
} from '../../components/image-details-dialog/image-details-dialog';
import { dialogConfig } from '../../dialogs';
import { ButtonModule } from 'primeng/button';
import { MatIcon } from '../../components/mat-icon/mat-icon';

@Component({
  selector: 'app-gallery',
  imports: [TranslatePipe, SkeletonModule, Masonry, ButtonModule, MatIcon],
  providers: [DialogService],
  templateUrl: './gallery.html',
  styleUrl: './gallery.scss',
})
export class Gallery {
  private dialogService = inject(DialogService);
  private api = inject(ApiService);

  selectedCategory = signal<TAGImageCategory>(undefined);

  categories = resource({
    defaultValue: [] as TAGImageCategory[],
    loader: ({}) => {
      return new Promise<TAGImageCategory[]>((resolve, reject) => {
        this.api.waitForAPI().then(() => {
          this.api
            .getImageCategories()
            .then((categories: TAGImageCategory[]) => {
              //resolve([]);
              categories.sort((a, b) => b.createdate.getTime() - a.createdate.getTime());
              resolve(categories.filter((c) => c.isPublic));
            })
            .catch((reason) => {
              reject(reason);
            });
        });
      });
    },
  });

  images = resource({
    params: () => ({ imageCategoryId: this.selectedCategory()?._id ?? undefined }),
    loader: ({ params }) => {
      return new Promise<TAGImage[]>((resolve, reject) => {
        if (!params.imageCategoryId) return resolve([]);

        this.api.waitForAPI().then(() => {
          this.api
            .getImages(params.imageCategoryId)
            .then((result: TAGImage[]) => {
              // TODO: Sort?
              resolve(result.filter((i) => i.isPublic));
            })
            .catch((reason) => {
              reject(reason);
            });
        });
      });
    },
  });

  getFormattedHTML(text: string) {
    return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }

  constructor() {
    effect(() => {
      if (this.categories.value()) {
        console.log('Selecting Default Category');

        let defaultCat = this.categories
          .value()
          .find((c) => c._id === this.api.config().defaultGallery);

        if (defaultCat) {
          this.selectCategory(defaultCat);
        }
      }
    });
  }

  selectCategory(cat: TAGImageCategory) {
    this.selectedCategory.set(cat);
  }

  openImageDetails(image: TAGImage) {
    const dialogRef = this.dialogService.open(
      ImageDetailsDialog,
      dialogConfig<ImageDetailsDialogData>({
        data: {
          image: image,
        },
        closable: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true
      }),
    );
  }
}
